import React from 'react'
import ReactDOM from 'react-dom'
import { ProductModal, ProductModalProps } from '@vend/business-components'
import { reactular } from '@vendhq/reactular'

const ProductModalWrapper: React.FC<{
  options: ProductModalProps
}> = ({ options }) => {
  return ReactDOM.createPortal(<ProductModal {...options} />, document.body)
}

export const reactProductModal = reactular(
  ProductModalWrapper,
  ['options'],
  'reactWrapper'
)
